import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ListGroup from 'react-bootstrap/ListGroup'
import LayoutSiaLearner from '../../../Shared/Layout/LayoutSiaLearner'
import { SIA_NAVY, SIA_GOLD_ACTIVE_BG, SIA_GOLD_ACTIVE_TEXT } from '../../../constants/siaTheme'

function DownloadIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 3v10.17l-3.88-3.88L6 11l6 6 6-6-1.12-1.12L13 13.17V3h-2zm-6 16v2h14v-2H5z" />
        </svg>
    )
}

const FormatosCatalog = ({ categories }) => {
    const [selectedId, setSelectedId] = useState(categories[0]?.id ?? null)

    useEffect(() => {
        if (!categories.length) {
            setSelectedId(null)
            return
        }
        if (!selectedId || !categories.some((c) => c.id === selectedId)) {
            setSelectedId(categories[0].id)
        }
    }, [categories, selectedId])

    const selected = categories.find((c) => c.id === selectedId)

    return (
        <>
            <p className="text-gray-700 fs-6 mb-8 lh-lg max-w-100">
                A continuación encontrarás formatos útiles para tu gestión. Elige una categoría y descarga el documento que necesites.
            </p>

            {categories.length === 0 ? (
                <p className="text-center text-muted py-15">Pronto publicaremos los formatos adicionales.</p>
            ) : (
                <Row className="g-6 g-lg-8 mb-15">
                    <Col lg={4} xl={3}>
                        <div className="rounded-3 border border-gray-200 shadow-sm overflow-hidden bg-white">
                            <div
                                className="px-4 py-3 text-white fw-bold text-uppercase fs-7"
                                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.05em' }}
                            >
                                Categorías
                            </div>
                            <ListGroup variant="flush">
                                {categories.map((c) => (
                                    <ListGroup.Item
                                        key={c.id}
                                        action
                                        onClick={() => setSelectedId(c.id)}
                                        className="py-3 px-4 border-0 rounded-0 fw-semibold"
                                        style={
                                            c.id === selectedId
                                                ? {
                                                      backgroundColor: SIA_GOLD_ACTIVE_BG,
                                                      color: SIA_GOLD_ACTIVE_TEXT,
                                                      borderColor: 'transparent',
                                                  }
                                                : { backgroundColor: '#fff' }
                                        }
                                    >
                                        {c.name}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </div>
                    </Col>
                    <Col lg={8} xl={9}>
                        <div className="rounded-3 border border-gray-200 shadow-sm bg-white p-6 p-lg-8" style={{ minHeight: '240px' }}>
                            {selected ? (
                                <>
                                    <h2 className="fs-4 fw-bold text-gray-900 mb-6 pb-3 border-bottom">{selected.name}</h2>
                                    {selected.documents.length === 0 ? (
                                        <p className="text-muted mb-0">No hay documentos en esta categoría.</p>
                                    ) : (
                                        <ul className="list-unstyled mb-0">
                                            {selected.documents.map((doc) => (
                                                <li
                                                    key={doc.id}
                                                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3 py-4 border-bottom border-gray-100"
                                                >
                                                    <span className="text-gray-900 fw-semibold flex-grow-1 pe-sm-4">{doc.title}</span>
                                                    {doc.has_download ? (
                                                        <a
                                                            href={
                                                                doc.external_url ||
                                                                route('sia.capacitacion.formatos.download', doc.id)
                                                            }
                                                            target={doc.external_url ? '_blank' : undefined}
                                                            rel={doc.external_url ? 'noopener noreferrer' : undefined}
                                                            className="d-inline-flex align-items-center justify-content-center rounded-1 text-decoration-none flex-shrink-0"
                                                            style={{ backgroundColor: SIA_GOLD_ACTIVE_BG, width: '42px', height: '42px' }}
                                                            title="Descargar"
                                                        >
                                                            <DownloadIcon />
                                                        </a>
                                                    ) : (
                                                        <span className="text-muted small">No disponible</span>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            )}
        </>
    )
}

FormatosCatalog.layout = (page) => <LayoutSiaLearner title="Formatos adicionales | SIA">{page}</LayoutSiaLearner>

export default FormatosCatalog
